<mat-toolbar>
    <button mat-icon-button (click)="drawer.toggle()">
        <mat-icon>menu</mat-icon>
    </button>
    <button mat-icon-button (click)="gotoPatreon()">
        <img src="./assets/patreon.png" />
    </button>
    <button mat-icon-button (click)="gotoDiscord()">
        <img src="./assets/discord.png" />
    </button>
    <app-command-bar></app-command-bar>
    <div>
        <button mat-icon-button matTooltip="Open Chat" class="mobile-only" (click)="open('chat')">
            <mat-icon [matBadge]="unreadMessages" [matBadgeHidden]="unreadMessages < 1" aria-hidden="false">chat</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Align Viewport to Revealed" (click)="fitViewExtents()">
            <mat-icon>fit_screen</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Upload File (Not Implemented)" (click)="uploadFile()">
            <mat-icon>add_to_photos</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Settings" (click)="open('user')">
            <mat-icon>settings</mat-icon>
        </button>
    </div>
</mat-toolbar>

<mat-sidenav-container>
    <mat-sidenav mode="over" #drawer>
        <div style="margin-top: 20px"></div>
        <button mat-button style="height:0px"></button>
        <button mat-button [routerLink]="['/room']"> <mat-icon>games</mat-icon> <span>Virtual Tabletop</span> </button>
        <button mat-button [routerLink]="['/campaign']"> <mat-icon>map</mat-icon> <span>Campaign Tracker</span> </button>
        <div class="divider"></div>
        <div style="margin-top: 40px;"></div>
        <button mat-button id="logout" (click)="logout()"> <mat-icon>exit_to_app</mat-icon> <span>Logout</span> </button>
    </mat-sidenav>
    <mat-sidenav mode="over" position="end" #rightdrawer>
        <app-chat #chat [unread]="unreadMessages" (unreadChange)="updateUnread($event)" id="chat-mobile" class="nav-content" *ngIf="isMobile" [ngClass]="{'show': show == 'chat' }"></app-chat>
        <app-settings id="user-settings" class="nav-content" [ngClass]="{'show': show == 'user' }" (complete)="closeDrawer()"></app-settings>
        <!-- <app-assets id="game-assets"></app-assets> -->
    </mat-sidenav>
    <mat-sidenav-content>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>

<footer appFooter></footer>
